import { css } from "@lit/reactive-element";
export const messageBarStyles = css `
	i {
		font-size: 16px
	}
`;
